import React, { createContext, useContext, useState, useEffect } from "react";

const DriverAuthContext = createContext(null);

export function DriverAuthProvider({ children }) {
  const [driver, setDriver] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("driver_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("driver_user");
    if (stored && token) {
      try { setDriver(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, [token]);

  const login = (userData, jwt) => {
    setDriver(userData);
    setToken(jwt);
    localStorage.setItem("driver_token", jwt);
    localStorage.setItem("driver_user", JSON.stringify(userData));
  };

  const logout = () => {
    setDriver(null);
    setToken(null);
    localStorage.removeItem("driver_token");
    localStorage.removeItem("driver_user");
  };

  return (
    <DriverAuthContext.Provider value={{ driver, token, login, logout, loading }}>
      {children}
    </DriverAuthContext.Provider>
  );
}

export const useDriverAuth = () => useContext(DriverAuthContext);